import { HourglassOutlined } from '@ant-design/icons';
import { Layout, Spin, Typography } from 'antd';
import { CSSProperties } from 'react';
import { useSelector } from 'react-redux';

import Logo from '../logo/Logo';

import { RootState } from '@/redux/store';

const { Text } = Typography;

const containerStyle: CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999,
};

type LoaderProps = {
  text?: string;
  'data-testid'?: string;
};

export const Loader = ({ text, 'data-testid': dataTestId }: LoaderProps) => {
  const currentTheme = useSelector(
    (state: RootState) => state.appSettings.currentTheme
  );

  return (
    <>
      <Layout
        data-testid={dataTestId}
        className="flex flex-col items-center justify-between h-full"
        style={{
          ...containerStyle,
          backgroundColor: currentTheme === 'dark' ? 'black' : 'white',
        }}
      >
        <div className="flex flex-col items-center gap-16">
          <Logo className="h-12 lg:h-20" />
          <Text
            style={{ color: currentTheme === 'dark' ? 'white' : 'black' }}
            className="text-xl flex gap-2"
          >
            {text}
            {text && (
              <span className="animate-spin">
                <HourglassOutlined />
              </span>
            )}
          </Text>
          <Spin
            size="large"
            style={{
              transform: 'scale(2)',
            }}
          />
        </div>
      </Layout>
    </>
  );
};
